"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
type UseRouteChangeParams = {
  onChangeStart?: () => void;
  onChangeComplete?: () => void;
};
export const useRouteChange = t0 => {
  const $ = _c(5);
  const {
    onChangeStart,
    onChangeComplete
  } = t0;
  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);
  let t1;
  let t2;
  if ($[0] !== onChangeComplete || $[1] !== onChangeStart || $[2] !== pathname) {
    t1 = () => {
      if (prevPathnameRef.current !== pathname) {
        if (onChangeStart) {
          onChangeStart();
        }
        if (onChangeComplete) {
          onChangeComplete();
        }
        prevPathnameRef.current = pathname;
      }
    };
    t2 = [pathname, onChangeStart, onChangeComplete];
    $[0] = onChangeComplete;
    $[1] = onChangeStart;
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
};